<korviu-input
  label="{{ 'auth.signup.password' | translate }}"
  class="block"
  [showErrorMessagesUnderField]="showErrorMessagesUnderField"
  [errorMessagesUnderField]="errorMessagesUnderField"
  [type]="isPasswordVisible ? 'text' : 'password'"
  [suffixIconType]="isPasswordVisible ? 'eye' : 'eye-closed'"
  [control]="passwordControl"
  (onSuffixClick)="isPasswordVisible = !isPasswordVisible"
></korviu-input>
@if (this.passwordRecommendationsAreVisible) {
  <div class="mt-4" translate="no">
    <div class="strength-bar-wrapper">
      <div
        class="strength-bar flex flex-row mb-1 gap-1"
        [ngClass]="{
          'very-weak': passwordIsVeryWeak,
          weak: passwordIsWeak,
          fair: passwordIsFair,
          strong: passwordIsStrong,
          'very-strong': passwordIsVeryStrong
        }"
      >
        @for (barId of [0, 1, 2, 3, 4]; track barId) {
          <div class="h-1 flex-1" id="bar-{{ barId }}"></div>
        }
      </div>
      <div
        class="strength-label mb-2 md:mb-4"
        [ngClass]="{
          red: passwordIsVeryWeak || passwordIsWeak,
          orange: passwordIsFair,
          blue: passwordIsStrong,
          green: passwordIsVeryStrong
        }"
      >
        <span [textContent]="passwordStrengthLocalizableLabel | translate"></span>
      </div>
      <div class="feedback flex flex-col md:gap-2">
        <ul class="criteria flex flex-col">
          <li [ngClass]="meetsMinLength ? 'met' : 'unmet'" data-testid="password-criterion-length">
            <span aria-hidden="true">{{ meetsMinLength ? '✓' : '•' }}</span>
            {{ 'validation.passwordStrength.criteria.minLength' | translate: { count: minPasswordLength } }}
          </li>
          <li [ngClass]="isNotEntirelyNumeric ? 'met' : 'unmet'" data-testid="password-criterion-not-numeric">
            <span aria-hidden="true">{{ isNotEntirelyNumeric ? '✓' : '•' }}</span>
            {{ 'validation.passwordStrength.criteria.notEntirelyNumeric' | translate }}
          </li>
        </ul>
        @if (serverWeakPasswordMessages.length) {
          <div class="validation-error flex flex-col" data-testid="password-server-reasons">
            @for (message of serverWeakPasswordMessages; track $index) {
              <span>{{ message.key ? (message.key | translate) : message.text }}</span>
            }
          </div>
        } @else if (passwordIsTooWeak || passwordControl.hasError('passwordIsWeak')) {
          <div class="validation-error">
            <span>
              {{
                'validation.passwordStrength.yourPasswordStrengthIsWeak'
                  | translate: { strength: passwordStrengthLocalizableLabel | translate | lowercase }
              }}
            </span>
          </div>
        }
        <div class="warning">
          <span [textContent]="warningLocalizableLabel | translate"></span>
        </div>
        <div class="suggestions flex flex-col">
          @for (suggestion of suggestions; track suggestion) {
            <span [textContent]="suggestionsMap.get(suggestion) | translate"></span>
          }
        </div>
      </div>
    </div>
  </div>
}
